import { render, staticRenderFns } from "./PersonaViewPage.vue?vue&type=template&id=308a7a36&scoped=true"
import script from "./PersonaViewPage.vue?vue&type=script&lang=js"
export * from "./PersonaViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a7a36",
  null
  
)

export default component.exports